import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";

export const getListRequestType = async () => {
  const dataAPI = await HttpService.get(
    ApiService.alesaForm.getListRequestType
  );

  return dataAPI.data.data;
};

export const getListRequestStatus = async () => {
  const dataAPI = await HttpService.post(
    ApiService.alesaForm.getListRequestStatus,
    {}
  );

  return dataAPI.data.data;
};

export const getCrrReport = async (
  requestTypeID?: string,
  requestStatusID?: string,
  crrNumberStatus?: string,
  startDateString?: string,
  endDateString?: string,
  roleId?: string,
  binusianID?: string,
  searchText?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaDashboard.getListCrrReport,
    JSON.stringify({
      RequestTypeID: requestTypeID,
      RequestStatusID: requestStatusID,
      CrrNumberStatus: crrNumberStatus,
      StartDateString: startDateString,
      EndDateString: endDateString,
      RoleId: roleId,
      BinusianID: binusianID,
      SearchText: searchText,
    })
  );

  return dataAPI.data.data;
};

export const deleteListOfRequest = async (
  listRequestID?: string[],
  userUp?: string
) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaDashboard.deleteListOfRequest,
    JSON.stringify({
      ListRequestID: listRequestID,
      UserUp: userUp,
    })
  );

  return dataAPI.data.data;
};
